<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\ja\newManual\changePassManual-1.png" alt="" /></div>
                <div>
                    <p>① 画面右上のユーザアイコンをクリックし、「個人設定」メニューを選択すると、「ユーザ情報管理画面」が表示されます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\changePassManual-2.png" alt="" /></div>
                <div>
                    <p>② 画面の左側にある「パスワード変更」タブをクリックすると、「パスワード変更」画面に切替えられます。</p>
                    <p>③ 画面上の「現在のパスワード」、「新しいパスワード」、「新しいパスワード（確認）」入力ボックスに入力し、「変更」ボタンを押下して下さい。</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/changePass_manual.vue